<template>
  <div>
    <div class="search-one">
      <div class="search-item">
        客户编号
        <Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入客户编号" clearable />
        发货单号
        <Input class='ml10 mr20 w200' v-model="screen_data.out_bill_no" placeholder="请输入发货单号" clearable />
        仓库
        <Select v-model="warehouse_id" @on-change="warehouseselectevent" class="w200" placeholder="请选择库房" clearable>
          <Option v-for="(option, index) in houseList" :value="option.warehouse_id" :key="index">
            {{option.warehouse_name}}
          </Option>
        </Select>
      </div>
      <div class="search-item">
        支付状态
        <Select v-model="screen_data.pay_status" style="width: 100px;" clearable>
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}
          </Option>
        </Select>
        创建时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200' clearable></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200' clearable></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="batchPay">批量支付</button>
        <button class="ivu-btn ivu-btn-primary fr ml20" @click="exportData">导出</button>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>
    </div>
    <div>
      <Table ref="data_list" :loading="loading" class="mt20" border :columns="table_data.columns"
        :data="table_data.data">
        <template slot-scope="{ row, index }" slot="opeate">
          <span @click="detail(row)" class="blue">详情</span>
          <span v-if="row.pay_status==0" @click="pay(row)" class="blue">支付</span>
        </template>
      </Table>
      <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </div>

    <Modal :title="title" v-model="show_detail" width="1000">
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
      </Table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
  import Paging from '@/components/common/paging'
  export default {
    components: {
      Paging,
    },
    data() {
      return {
        houseList: [],
        warehouse_id: '',
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        statusList: [{
          value: '',
          label: '全部'
        }, { //10-待结算，20-已结算，-10-已作废
          value: 0,
          label: '待付款'
        }, {
          value: 1,
          label: '已付款'
        }, {
          value: '-1',
          label: '已作废'
        }],
        detail_columns: [{
          title: '快递机构',
          key: 'waybill_name',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '快递单号',
          key: 'waybill_code',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '运单号',
          key: 'in_bill_no',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '重量(LBS)',
          key: 'weight',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '初次扫描时间',
          key: 'create_date',
          tooltip: true,
          width: 200,
        }],
        detail_list: [], //详情列表
        show_detail: false,
        title: ''
      }
    },
    methods: {
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList(this.active);
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList(this.active);
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList(this.active);
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      getList() {
        this.$axios.get('/ClientBill/fee/fh/out/bill', {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            res.data.forEach(item => {
              item._disabled = true; //默认禁用
              if (item.pay_status == 0) { //待支付
                item._disabled = false
              }
            })
            this.table_data.data = res.data;
          } else {
            this.table_data.data = [];
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      detail(data) {
        this.title = '发货单号' + data.out_bill_no + '详情'
        this.$axios.get('/ClientBill/fee/fh/out/bill/detail', {
          params: {
            out_bill_no: data.out_bill_no,
            pageNum: 1,
            pageSize: 99
          }
        }, {
          headers: {
            noShowError: true
          }
        }).then(res => {
          this.detail_list = res.data || [];
          this.show_detail = true;
        })
      },
      setColumns() {
        let arr = [{
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          }, {
            title: '发货单号',
            key: 'out_bill_no',
            tooltip: true,
            width: 170,
          }, {
            title: '子账户编号',
            key: 'client_code',
            tooltip: true,
            width: 150,
          },
          {
            title: '所属仓库',
            key: 'warehouse_name',
            tooltip: true,
            width: 150,
          },
          {
            title: '客户姓名',
            key: 'client_name',
            tooltip: true,
            width: 150,
          }, {
            title: '包裹数',
            key: 'packages',
            width: 150,
          }, {
            title: '重量(LBS)',
            key: 'weight',
            width: 150,
          }, {
            title: '总金额(USD)',
            key: 'total_fee',
            width: 150,
          },
          {
            title: "状态",
            key: "pay_status",
            width: 100,
            render: (h, params) => {
              let status = params.row.pay_status;
              if (status == 0) {
                return h("span", {
                  style: {
                    color: 'red'
                  }
                }, "待支付");
              } else if (status == 1) {
                return h("span", {
                  style: {
                    color: 'green'
                  }
                }, "已支付");
              } else if (status == -1) {
                return h("span", "已作废");
              }
            }
          }, {
            title: '支付时间',
            key: 'pay_date',
            width: 190,
            tooltip: true
          }, {
            title: '费用产生日期',
            key: 'create_date',
            width: 190,
            tooltip: true
          }, {
            title: '操作',
            slot: 'opeate',
            fixed: 'right',
            width: 150
          }
        ];
        return arr;
      },
      exportData() {
        this.$axios.get('/ClientBill/fee/fh/out/bill/excel', {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      pay(data) {
        const that = this;
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付账单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            that.payDirectly(data);
          },
          onCancel: () => {

          }
        });
      },
      payDirectly(data) {
        this.$axios.post('/ClientBill/fee/pay/fh/out/bill?out_bill_no=' + data.out_bill_no).then(res => {
          if (res.success) {
            this.$Message.success('支付成功');
            this.getList();
          }
        })
      },
      batchPay() {
        let items = this.$refs.data_list.getSelection();
        if (items.length == 0) {
          this.$Message.error('请选择要支付的账单');
          return;
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确定要支付账单吗？</p><p>此操作将无法撤销！</p>',
          onOk: () => {
            let bill_nos = items.map(v => v.out_bill_no);
            this.$axios.post('/ClientBill/batch/pay', this.$qs.stringify({
              fee_type: 403,
              bill_nos: bill_nos.join()
            })).then(res => {
              if (res.success) {
                this.$Message.info(res.data);
                this.getList();
              }
            })
          },
          onCancel: () => {

          }
        });
      },
      warehouseselectevent(e) {
        if (e == undefined) e = "";
        this.screen_data.warehouse_id = e;
        console.log("仓库id产生编号：" + e)
      },
      init() {
        this.table_data.columns = this.setColumns()
        this.getList()
        //进行仓库查询 houseList
        this.$axios.get("warehouse/list").then(res => {
          if (res.success && res.data) {
            this.houseList = res.data;
          }
        })

      }
    },
    created() {
      this.init()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/finance/bill/zhongzhuanfahuo.vue